/**
 * @desc 查询所有平台站点
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlatformSiteRpcResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/platformSite/selectAll`, {
      method: "GET",

      ...options,
    }),
  );
}
